import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ControllerService } from './shared/service/controller.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent {
  locale: string;

  constructor(
    private translate: TranslateService,
    private controller: ControllerService
  ) {
    this.translate = translate;

    console.log('hands-off-my-chocolate')

    const el = document
      .getElementById('form-donate')
      .firstElementChild;

    if (el.hasAttribute('donate-once')) {
      this.controller.donateOnce = true;
    }
    if (el.hasAttribute('known-from-list')) {
      this.controller.showKnownFromList = true;
      console.log('setting knownFromList!!');
    }
    if (el.hasAttribute('group-code')) {
      this.controller.groupcode = el.getAttribute('group-code');
    }
    if (el.hasAttribute('locale')) {
      this.locale = el.getAttribute('locale');
      console.warn('setting locale');
    } else {
      console.warn('Couldnt read locale setting default');
      this.locale = 'nl_nl';
    }

    console.log(
      'pathname.split: ' +
        window.location.pathname.split('/') +
        ' -> ' +
        (window.location.pathname.split('/')[1] || 'nonoo')
    );
    this.translate.getTranslation(this.locale.substring(0, 2));
    this.translate.setDefaultLang(this.locale.substring(0, 2));
    this.controller.locale = this.locale;
  }
}
export function getTranslationPrefix():string {
  const el = document.getElementById('form-donate').firstElementChild;
  let prefix = '';
  if (el.hasAttribute('translation-prefix')) {
    prefix = el.getAttribute('translation-prefix') + '/';
  }
  return prefix
}
